import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-next-gray-md mb-3 flex items-stretch p-3 gap-3" }
const _hoisted_2 = { class: "basis-1/3 flex flex-col justify-between" }
const _hoisted_3 = { class: "basis-1/3 flex flex-col justify-between" }
const _hoisted_4 = { class: "basis-1/3 flex flex-col justify-between" }
const _hoisted_5 = { class: "basis-1/3 flex flex-col justify-between" }
const _hoisted_6 = { class: "basis flex flex-col self-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-bold" }, "Nome", -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.c.full_name), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-bold" }, "Denominazione azienda", -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.c.denominazione_azienda), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-bold" }, "Telefono", -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.c.telefono_1), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.c.telefono_2), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-bold" }, "Email", -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.c.email), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_NextButton, {
        variant: "outline-secondary",
        component: "router-link",
        to: {
                    name: 'DettaglioContatto',
                    params: { id: _ctx.c.cliente_id, cid: _ctx.c.id },
                },
        class: "sm:block py-1 px-3"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" Vedi ")
        ])),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}